import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function ThumbnailDownloader() {
  const [url, setUrl] = useState("");
  const [thumbUrl, setThumbUrl] = useState("");
  const [videoId, setVideoId] = useState("");

  const extractVideoId = (youtubeUrl) => {
    const match = youtubeUrl.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
  };

  const handleGenerate = () => {
    const extractedId = extractVideoId(url);
    if (extractedId) {
      setVideoId(extractedId);
      setThumbUrl(`https://img.youtube.com/vi/${extractedId}/maxresdefault.jpg`);
    } else {
      alert("Please enter a valid YouTube URL");
      setThumbUrl("");
      setVideoId("");
    }
  };

  const downloadImage = (thumbUrl) => {
    const fileName = `youtube-thumbnail-${videoId || "video"}.jpg`;

    fetch(thumbUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      })
      .catch(() => alert("Download failed. Please try again."));
  };

  return (
    <>
      <Helmet>
        <title>YouTube Thumbnail Downloader - Free HD Image</title>
        <meta
          name="description"
          content="Download HD YouTube video thumbnails easily. Paste any video URL to get the thumbnail image instantly. Free online tool for all devices."
        />
        <meta
          name="keywords"
          content="youtube thumbnail downloader, download youtube thumbnails, youtube video thumbnail, free youtube thumbnail tool, hd youtube thumbnail download, youtube thumbnail image"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/youtube-thumbnail-downloader" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>YouTube Thumbnail Downloader</h2>

          <input
            type="text"
            placeholder="Paste YouTube video URL"
            className="form-control mb-3"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />

          <button className="btn btn-primary mb-4" onClick={handleGenerate}>
            Get Thumbnail
          </button>

          {thumbUrl && (
            <div className="text-center">
              <img src={thumbUrl} alt="YouTube Thumbnail" className="img-fluid mb-3" />
              <br />
              <button className="btn btn-success" onClick={() => downloadImage(thumbUrl)}>
                Download Thumbnail
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
